import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';

const VIEWPORT_PADDING = 8;

const CustomDropdown = ({ children, ContentComponent, isRight, onClose = () => {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      onClose();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional effect scope
  }, [isOpen])

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useLayoutEffect(() => {
    const keepMenuInViewport = () => {
      const menu = menuRef.current;
      if (!menu) {
        return;
      }

      menu.style.transform = '';
      const rect = menu.getBoundingClientRect();
      const minX = VIEWPORT_PADDING;
      const maxX = window.innerWidth - VIEWPORT_PADDING;
      let shiftX = 0;

      if (rect.right > maxX) {
        shiftX = maxX - rect.right;
      }
      if (rect.left + shiftX < minX) {
        shiftX = minX - rect.left;
      }

      if (shiftX !== 0) {
        menu.style.transform = `translateX(${shiftX}px)`;
      }
    };

    if (!isOpen) {
      return;
    }

    keepMenuInViewport();
    window.addEventListener('resize', keepMenuInViewport);
    return () => {
      window.removeEventListener('resize', keepMenuInViewport);
    };
  }, [isOpen]);

  return (
    <div ref={dropdownRef} className="relative inline-block max-w-full">
      <div onClick={handleToggle}>
        {children}
      </div>
      {isOpen && (
        <div
          ref={menuRef}
          style={{
            position: 'absolute',
            top: '100%',
            right: isRight ? 0 : 'auto',
            left: isRight ? 'auto' : 0,
            zIndex: 200,
            maxWidth: `calc(100vw - ${VIEWPORT_PADDING * 2}px)`,
          }}
          className="mt-1 rounded-lg border border-mute-200 shadow-md"
        >
          {ContentComponent ? ContentComponent() : null}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
